import { z } from 'zod';

export const RecommendedJobSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable(),
});
export type RecommendedJob = z.infer<typeof RecommendedJobSchema>;

export const RecommendedJobsResponseSchema = z.object({
  items: z.array(RecommendedJobSchema),
});
export type RecommendedJobsResponse = z.infer<typeof RecommendedJobsResponseSchema>;

export const DepartmentSchema = z.object({
  id: z.string(),
  name: z.string(),
});
export type Department = z.infer<typeof DepartmentSchema>;

export const DepartmentsResponseSchema = z.object({
  items: z.array(DepartmentSchema),
});
export type DepartmentsResponse = z.infer<typeof DepartmentsResponseSchema>;

export const StarterPreviewMemberSchema = z.object({
  name: z.string(),
  role: z.string().nullable(),
  department: z.string().nullable(),
});
export type StarterPreviewMember = z.infer<typeof StarterPreviewMemberSchema>;

export const StarterPreviewResponseSchema = z.object({
  members: z.array(StarterPreviewMemberSchema),
});
export type StarterPreviewResponse = z.infer<typeof StarterPreviewResponseSchema>;
